import { reportEvent } from './qms';
import { getCookie } from './cookie';

/**
 * 轻量级API监控
 * 监控特定接口的请求参数、响应数据和网络耗时
 * 超时阈值：60秒
 */
class APIMonitor {
  /** 监控白名单 - 需要监控的接口路径 */
  private whiteList: Set<string> = new Set();

  /** 请求开始时间记录 */
  private requestTimes: Map<string, { startTime: number; config: any }> =
    new Map();

  /** 最大记录数限制 */
  private readonly MAX_RECORDS = 1000;

  /** 超时阈值：60秒 */
  private readonly TIMEOUT_THRESHOLD = 60000;

  private whs = '';

  private whsList = ['CNH'];

  constructor() {
    this.whs = getCookie('setting_whs_v2') || '';

    if (!this.whsList.includes(this.whs)) return;
    // 配置需要监控的接口
    this.whiteList.add(
      '/api/v2/apps/process/outbound/checking/print_checking_label'
    );
    this.whiteList.add(
      '/api/v2/apps/process/outbound/checking/search_checking_task_info'
    );
  }

  /**
   * 记录请求开始
   */
  public recordRequest(config: any): void {
    if (!this.whiteList.has(config.url)) return;

    // 内存泄漏防护:限制最大记录数
    if (this.requestTimes.size >= this.MAX_RECORDS) {
      const oldestKey = this.requestTimes.keys().next().value;
      this.requestTimes.delete(oldestKey);
    }

    const key = `${config.url}_${Date.now()}_${Math.random()}`;
    config._monitorKey = key;

    this.requestTimes.set(key, {
      startTime: Date.now(),
      config: {
        url: config.url,
        method: config.method,
        params: config.params,
        data: config.data,
      },
    });
  }

  /**
   * 记录响应结果
   */
  public recordResponse(response: any): void {
    const key = response.config?._monitorKey;
    if (!key) return;

    const record = this.requestTimes.get(key);
    if (!record) return;

    const duration = Date.now() - record.startTime;
    const isTimeout = duration > this.TIMEOUT_THRESHOLD;

    // 上报监控数据（正常和超时都上报）
    try {
      const res = {
        type: isTimeout ? 'timeout' : 'success',
        url: record.config.url,
        method: record.config.method,
        duration,
        isTimeout,
        params: record.config.params,
        data: record.config.data,
        // response: response.data,
        timestamp: Date.now(),
      };
      reportEvent('wms_custom_api_monitor', {
        res: JSON.stringify(res),
      });
    } catch (e) {
      console.warn('[APIMonitor] 接口监控数据上报失败:', e);
    }

    this.requestTimes.delete(key);
  }

  /**
   * 记录请求错误
   */
  public recordError(error: any): void {
    const key = error.config?._monitorKey;
    if (!key) return;

    const record = this.requestTimes.get(key);
    if (!record) return;

    const duration = Date.now() - record.startTime;

    // 上报错误
    try {
      const res = {
        type: 'error',
        url: record.config.url,
        method: record.config.method,
        duration,
        params: record.config.params,
        data: record.config.data,
        error: {
          message: error.message,
          code: error.code,
          status: error.response?.status,
        },
        timestamp: Date.now(),
      };
      reportEvent('wms_custom_api_monitor', {
        res: JSON.stringify(res),
      });
    } catch (e) {
      console.warn('[APIMonitor] 接口错误数据上报失败:', e);
    }

    this.requestTimes.delete(key);
  }
}

export default new APIMonitor();
